module.exports = __webpack_public_path__ + "static/media/iphone-x-chordpro-reduced.3143ef70.png";